import Characters from './characters';
export default Characters;